export default __webpack_public_path__ + "static/media/VysionTrademarkR 725x242.fc5c5850.png";